import { loggedIn, invoiceNeedsPaying } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import { setDeliveryPrefFlow } from '../../../redux/modules/orders';

// eslint-disable-next-line import/prefer-default-export
export const page = {
  path: paths.checkout.paymentMethod,
  isAllowed: [loggedIn, invoiceNeedsPaying],
  action: () => setDeliveryPrefFlow('checkoutMethod')
};
